import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { TopNav } from './TopNav';
export const AdminLayout = () => {
    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
    return (_jsxs("div", { className: "h-screen flex flex-col overflow-hidden", children: [_jsx(TopNav, { onToggleSidebar: () => setIsSidebarCollapsed(!isSidebarCollapsed) }), _jsxs("div", { className: "flex flex-1 overflow-hidden", children: [_jsx(Sidebar, { isCollapsed: isSidebarCollapsed }), _jsx("main", { className: "flex-1 overflow-y-auto bg-gray-50", children: _jsx("div", { className: "max-w-7xl mx-auto p-6", children: _jsx(Outlet, {}) }) })] })] }));
};
